import { render } from "./ProviderboxShow.vue?vue&type=template&id=5822877b"
import script from "./ProviderboxShow.vue?vue&type=script&lang=js"
export * from "./ProviderboxShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__